import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";

export const EmptyCell = memo(() => <ViewTableCell>&nbsp;</ViewTableCell>);
